const mode = state => state.mode
const page = state => state.page
const pages = state => state.pages
const isPublic = state => state.isPublic

export default {
  mode,
  page,
  pages,
  isPublic
}
